import { render } from "./PublicHome.vue?vue&type=template&id=67f65465&scoped=true"
import script from "./PublicHome.vue?vue&type=script&lang=js"
export * from "./PublicHome.vue?vue&type=script&lang=js"

import "./PublicHome.vue?vue&type=style&index=0&id=67f65465&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f65465"]])

export default __exports__